export default __webpack_public_path__ + "static/media/Animations_Bar5.91d90c57.svg";